module.exports = __webpack_public_path__ + "img/ser2.d47bcfdb.png";